import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './Responsive.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home';
import SignIn from './Pages/SignIn';
import Dashboard from './Pages/Dashboard';
import Settings from './Pages/Settings';
import Profile from './Pages/Profile';
import RewardsPoints from './Pages/RewardsPoints';
import ReedemPoints from './Pages/ReedemPoints';
import SendBulkSMS from './Pages/SendBulkSMS';
import SenderID from './Pages/SenderID';
import TermsOfUse from './Pages/TermsOfUse';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import DeleteAccount from './Pages/DeleteAccount';
import SenderIdTemplates from './Pages/SenderIdTemplates';
import Credit from './Pages/Credit';
import APIDocs from './Pages/APIDocs';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/signin' element={<SignIn/>}/>
        <Route path='/login' element={<SignIn/>}/>
        <Route path='/signup' element={<SignIn/>}/>
        <Route path='/api' element={<APIDocs/>}/>

        <Route path='/dashboard' element={<Dashboard/>}/>
        <Route path='/settings' element={<Settings/>}/>
        <Route path='/profile' element={<Profile/>}/>
        <Route path='/credit' element={<Credit/>}/>

        <Route path='/reward-points' element={<RewardsPoints/>}/>
        <Route path='/reedem-points' element={<ReedemPoints/>}/>
        <Route path='/send-sms' element={<SendBulkSMS/>}/>
        
        <Route path='/sender-id' element={<SenderID/>}/>

        <Route path='/terms-of-use' element={<TermsOfUse/>}/>
        <Route path='/privacy' element={<PrivacyPolicy/>}/>
        <Route path='/delete-account' element={<DeleteAccount/>}/>
        <Route path='/sender-id-templates' element={<SenderIdTemplates/>}/>
      </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
